module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-02.207802a4.png";